<!-- #166 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5"
        style="color: #23468c; font-weight: 500"
      >
        Base Cities List
      </div>
      <v-spacer></v-spacer>
      <v-btn
        color="info"
        class="float-right mr-3"
        small
        :loading="downloader"
        @click="download()"
        >Download</v-btn
      >
      <v-btn
        color="primary"
        class="float-right mr-3"
        small
        @click="uploadCountry()"
        >Upload</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-dialog
      v-model="uploadCountrypopup"
      max-width="550px"
      @keydown.esc="uploadCountrypopup = false"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="headline">Upload City</span>
        </v-card-title>
        <v-divider class="mt-1 mb-4"></v-divider>

        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col>
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  label="Select file"
                  :rules="[(v) => !!v || 'Please select File']"
                  dense
                  outlined
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                >
                </v-file-input>
                <v-btn
                  color="primary"
                  dark
                  class="mt-3"
                  :loading="fileLoader"
                  @click="upload"
                >
                  Upload
                </v-btn>

                <v-btn
                  class="mt-3 ml-3"
                  @click="(uploadCountrypopup = false), $refs.form.reset()"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="cities"
      :options.sync="options"
      :loading="tokenLoader"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:top>
        <v-form @submit.prevent="searchAll" type="submit">
          <v-row class="custom-row pl-5 pr-5">
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="country"
                :items="countries"
                outlined
                dense
                chips
                item-text="name"
                item-value="code"
                small-chips
                label="Country"
                clearable
                @click:clear="clearInput('this.country')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="city"
                :items="citiesListed"
                outlined
                dense
                chips
                item-text="name"
                item-value="name"
                small-chips
                label="City"
                clearable
                @click:clear="clearInput('this.city')"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="status"
                :items="statuses"
                outlined
                dense
                chips
                item-text="text"
                item-value="value"
                small-chips
                label="Active"
                clearable
                @click:clear="clearInput('this.status')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" class="text-end pr-4 mb-2">
              <v-btn class="success" color="primary" @click="searchAll"
                >Search</v-btn
              >
              <v-btn color="white" class="ml-4" @click="clearAll">Clear</v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="mb-2 mt-2"></v-divider>
      </template>
      <template v-slot:[`item.status`]="{ item }"
        >{{ item.status == true ? "True" : "False" }}
      </template>
    </v-data-table>

    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
    />
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: {
    BulkErrors,
  },
  created() {
    this.fetchList();
    this.getCountryList();
  },
  data() {
    return {
      statuses: [
        { text: "Yes", value: "True" },
        { text: "No", value: "False" },
      ],
      downloader: false,
      uploadedItem: {},
      uploadResDialog: false,
      fileLoader: false,
      uploadCountrypopup: false,
      options: {},
      cities: [],
      name: "",
      countries: [],
      headers: [
        {
          text: "Name",
          value: "name",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Code",
          value: "city_code",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Active",
          value: "status",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
      ],
      country: null,
      city: null,
      status: null,
      citiesListed: [],
    };
  },

  methods: {
    ...mapActions([
      "snackBar",
      "uploadBaseCountry",
      "getCities",
      "downloadBaseCountry",
      "getCountries",
    ]),
    getCountryList() {
      this.getCountries().then((res) => {
        this.countries = res.data;
      });
    },
    clearInput(value) {
      if (value == "this.country") {
        this.country = null;
      } else if (value == "this.city") {
        this.city = null;
      } else if (value == "this.status") {
        this.status = null;
      }
    },
    allFilters() {
      this.loader = true;
      let obj = {
        status: this.status,
        city_name: this.city,
      };

      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.allFilters();
      if (this.country !== null) {
        this.$route.params.code = this.country;
      }
      this.cityLoader = true;

      this.getCities({
        countryCode: this.$route.params.code,
        params: {
          ...this.filtersArr,
        },
      })
        .then((res) => {
          this.cities = res.data;
        })
        .catch(() => {
          this.cityLoader = false;
        });
    },
    clearAll() {
      this.status = null;
      this.city = null;
      this.country = null;
      this.fetchList();
    },
    download() {
      const payload = new FormData();
      if (this.country !== null) {
        this.$route.params.code = this.country;
        let data = this.countries.find((e) => {
          return e.code == this.country;
        });
        this.$route.params.id = data.id;
      }
      if (this.status == null) {
        this.status = "True";
      }
      payload.append("country_id", this.$route.params.id);
      let data = {
        params: payload,
        status: this.status,
      };
      this.downloadBaseCountry(data)
        .then((res) => {
          this.fileDownload(res);
        })
        .catch(() => {});
    },
    uploadCountry(item) {
      this.uploadedItem = item;
      this.uploadCountrypopup = true;
    },

    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      payload.append("data_file", this.file);
      payload.append("country_id", this.$route.params.id);
      this.uploadBaseCountry(payload)
        .then((res) => {
          this.fileLoader = false;
          this.dialog = false;
          this.uploadRes = res.data;
          this.uploadResDialog = true;
          this.uploadedItem = {};
          this.uploadCountrypopup = false;

          this.fetchList();
        })
        .catch(() => {
          this.fileLoader = false;
          this.uploadCountrypopup = false;
        });
    },
    fetchList() {
      this.getCities({
        countryCode: this.$route.params.code,
        params: {
          pagination: 0,
          fields: "id,name",
        },
      })
        .then((res) => {
          this.cities = res.data;
          this.citiesListed = res.data;
        })
        .catch(() => {
          this.cityLoader = false;
        });
    },
  },
};
</script>
